import { render, staticRenderFns } from "./dbViewList.vue?vue&type=template&id=6dc90340&scoped=true&"
import script from "./dbViewList.vue?vue&type=script&lang=js&"
export * from "./dbViewList.vue?vue&type=script&lang=js&"
import style0 from "./dbViewList.vue?vue&type=style&index=0&id=6dc90340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc90340",
  null
  
)

export default component.exports